// delete-course — shared "delete the entire course" helper.
// Per陛下 19AQ: ChapterCard surfaces a quick delete button that calls the
// same flow as course-settings-view.deleteCourse(). Centralized so any view
// invoking deletion follows identical PDF / result / progress / draft cleanup
// order (PDFs first to avoid orphaning, then result + progress + draft).

import type { CourseDraft } from '@examforge/shared/schemas';
import { deletePdf, deleteResult, deleteProgress, deleteDraft } from '../storage/idb.js';

/**
 * Delete every IDB record associated with this course.
 *   - source PDFs (sources[].sha256 + legacy source.sha256 + legacy pastPapers[])
 *   - results record
 *   - progress record
 *   - draft itself
 *
 * Caller is responsible for confirm dialogs (this function does NOT prompt)
 * and for navigation afterwards (most callers `navigate('/')`).
 */
export async function deleteEntireCourse(draft: CourseDraft): Promise<void> {
  const seen = new Set<string>();
  for (const slot of draft.sources ?? []) {
    if (seen.has(slot.sha256)) continue;
    seen.add(slot.sha256);
    await deletePdf(slot.sha256).catch(() => {});
  }
  // Legacy field cleanup — pre-19AD drafts may still carry these.
  if (draft.source && !seen.has(draft.source.sha256)) {
    await deletePdf(draft.source.sha256).catch(() => {});
  }
  for (const upload of draft.pastPapers ?? []) {
    if (!seen.has(upload.sha256)) await deletePdf(upload.sha256).catch(() => {});
  }
  await deleteResult(draft.id).catch(() => {});
  await deleteProgress(draft.id).catch(() => {});
  await deleteDraft(draft.id);
}
